import { useState } from "react";
import { Box, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { AccountTreeOutlined, FullscreenOutlined } from "@mui/icons-material";
import DiagramaEquipamentosPreview from "../../circuito/diagramaEquipamentos/DiagramaEquipamentosPreview";
import FormWoman from "../../../../../../components/artsPersonComponent/formWoman";
import useStyles from "./styles";

// Seção "Diagrama de Equipamentos" do preview (read-only): mesma fronteira
// aplicada ao modo edição na Task 6 (DiagramaTab). Extraída de
// previewData.js (Task 7 da decomposição), mesmo JSX/comportamento.
export default function DiagramaPreview({ form, clientHosts, servico, isActive }) {
	const theme = useTheme();
	const styles = useStyles();
	const [isDiagramExpanded, setIsDiagramExpanded] = useState(false);
	const temDiagrama = (form?.diagramaEquipamentos?.nodes?.length || 0) > 0;

	return (
		<>
			<Box sx={styles.boxContent}>
				<AccountTreeOutlined color="primary" />
				<Typography variant="mySubtitle2">
					Diagrama de Equipamentos
				</Typography>
				{temDiagrama && !isDiagramExpanded && (
					<Tooltip title="Ampliar diagrama" arrow>
						<IconButton
							size="small"
							color="primary"
							sx={{ marginLeft: "auto" }}
							onClick={() => setIsDiagramExpanded(true)}
							aria-label="Ampliar diagrama"
						>
							<FullscreenOutlined fontSize="small" />
						</IconButton>
					</Tooltip>
				)}
			</Box>
			<Box sx={{ px: 2, py: 1 }}>
				{temDiagrama ? (
					<DiagramaEquipamentosPreview
						nodes={form?.diagramaEquipamentos?.nodes}
						edges={form?.diagramaEquipamentos?.edges}
						isExpanded={isDiagramExpanded}
						onToggleExpanded={() => setIsDiagramExpanded((prev) => !prev)}
						isActive={isActive}
						hostOptions={clientHosts?.[servico] || []}
					/>
				) : (
					// Sem diagrama: ilustração no lugar do texto simples, mesmo padrão do clientesSwap
					<FormWoman
						mainFill={theme.palette.secondary.dark}
						mainText={{ before: "Parece que ainda não\nhá ", highlight: "Diagrama", after: " por aqui." }}
						subText={"O diagrama aparecerá\nassim que for criado"}
					/>
				)}
			</Box>
		</>
	);
}
